import { LoanMultiplier, LoopscalePointsAction, RewardPointsPerSecond } from "@bridgesplit/abf-react";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";

import { LoopscalePointStatProps } from "./stats";

export interface PointsPerDayParams extends LoopscalePointStatProps {
    loanMultipliers: LoanMultiplier | undefined;
    rewardPointsPerSecond: RewardPointsPerSecond | undefined;
    estimateSeconds: number;
    color: string;
}

export function getLoopscalePointsPerUnitTime(
    loopscalePointsAction: LoopscalePointsAction,
    metadata: TokenListMetadata | undefined,
    estimateSeconds: number,
    totalPrincipalAmountUsd: number | undefined,

    rewardPointsPerSecond: RewardPointsPerSecond | undefined,
    loanMultipliers: LoanMultiplier | undefined
) {
    const pointPerSecond = rewardPointsPerSecond?.[loopscalePointsAction]?.pointsPerSecond;
    const loanMultiplier = metadata ? loanMultipliers?.[metadata.mint]?.[loopscalePointsAction]?.multiplier : 1;

    const pointsPerUnitTime =
        (pointPerSecond ?? 0) * (loanMultiplier ?? 1) * (totalPrincipalAmountUsd ?? 0) * estimateSeconds;
    return pointsPerUnitTime;
}
